import React from 'react';
import { LinkWrapper, CardLinkText } from '@components/Card/Card.styled';
import Link from '@components/Link/Link';
import { CodingConstants } from '@constants';
import { NewCardWrapper } from '@components/NewCard/NewCard.styled';
import { WidgetWrapper, Title, Content } from '@components/Widget/Widget.styled';
import { selectEligibleForEscrowComplete, selectEligibleForEscrowScheduled } from '@store/selectors/widgets.selectors';
import { useSelector } from 'react-redux';
import { CaretRightIcon } from 'shared-ui-components';

//TODO - need to move this to bundle offer template card
const EscrowAnalysisWidget: React.FC<any> = ({ loanType, account, themeType }) => {
    const { accountNumber } = account;

    const eligibleForEscrowComplete = useSelector(selectEligibleForEscrowComplete);
    const eligibleForEscrowScheduled = useSelector(selectEligibleForEscrowScheduled);

    const isEligibleForEscrowComplete = eligibleForEscrowComplete?.initParam?.find(({ loanNumber }) => loanNumber === accountNumber);

    const eligibleForEscrow = isEligibleForEscrowComplete;

    const { escrow } = CodingConstants;
    const handleEscrowNavigation = () => {
        loanType(escrow);
    };
    return (
        <>
            {eligibleForEscrow && (
                <NewCardWrapper themeType={themeType}>
                    <WidgetWrapper>
                        <img
                            src="https://dam.freedommortgage.com/dx/api/dam/v1/collections/e9810627-8508-4c5f-b7f1-91b83e5c5489/items/3b0ff8ef-c0d0-455f-8ab4-940035dfa5b8/renditions/ebd46849-4bc1-478a-829b-6ddb1bc7994a?binary=true"
                            width={54}
                            height={60}
                        />
                        <Title>Escrow Analysis Ready</Title>
                    </WidgetWrapper>
                    <Content>Your escrow analysis is complete. Your payment may be changing. View your analysis to learn more.</Content>
                    <LinkWrapper id="cardLink">
                        <CardLinkText>
                            <Link onClick={handleEscrowNavigation}>VIEW ANALYSIS</Link>
                            {/*eslint-disable-next-line @typescript-eslint/ban-ts-comment*/}
                            {/*@ts-ignore*/}
                            <CaretRightIcon style={{ marginBottom: '4px' }} />
                        </CardLinkText>
                    </LinkWrapper>
                </NewCardWrapper>
            )}
        </>
    );
};
export default React.memo(EscrowAnalysisWidget);
